"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Button = function Button(props) {
  var allClassNames = 'sc-button';

  var clickHandler = function clickHandler(e) {
    if (props.onClick) {
      props.onClick(e);
    }
  };

  if (props.classNames && props.classNames.length > 0) {
    allClassNames += " ".concat(props.classNames.reduce(function (acc, curr) {
      return "".concat(acc, " ").concat(curr);
    }));
  }

  if (props.id) {
    return /*#__PURE__*/_react.default.createElement("button", {
      title: props.title,
      disabled: props.disabled,
      onClick: clickHandler,
      id: props.id,
      className: allClassNames
    }, props.children);
  }

  return /*#__PURE__*/_react.default.createElement("button", {
    title: props.title,
    disabled: props.disabled,
    onClick: clickHandler,
    className: allClassNames
  }, props.children);
};

Button.propTypes = {
  children: _propTypes.default.string.isRequired,
  classNames: _propTypes.default.arrayOf(_propTypes.default.string),
  id: _propTypes.default.string,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  title: _propTypes.default.string
};
var _default = Button;
exports.default = _default;